import { isFunction } from '../is-function/is-function';
import { isConstructor } from '../is-constructor/is-constructor';
import { isString } from '../is-string/is-string';
import type { StringResolver } from '@pct-ts/typing';

export function isStringResolver<T>(value: unknown): value is StringResolver<T> {
  return isString(value) || (isFunction(value) && !isConstructor(value));
}
